import React from 'react';
import { G, Path } from 'react-native-svg';

import { IconDef } from './types';

export const User: IconDef = {
  svg: (
    <G>
      <Path
        d="M2 21.4436C4.59532 18.6909 8.11891 16.9991 12 16.9991C15.8811 16.9991 19.4047 18.6909 22 21.4436M17 7.55469C17 10.3161 14.7614 12.5547 12 12.5547C9.23858 12.5547 7 10.3161 7 7.55469C7 4.79326 9.23858 2.55469 12 2.55469C14.7614 2.55469 17 4.79326 17 7.55469Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
  ),
  svgStyles(color) {
    return {
      stroke: color,
    };
  },
};
